/**
 * Per-project defaults for a NEW issue (an existing issue always keeps its
 * saved values).
 *
 * source_entity_extra_attributes.issue_default_internal (boolean):
 *  - missing / null / true -> a new issue starts Internal (the long-standing
 *    behaviour, so every project without the key is unchanged);
 *  - false -> a new issue starts external (Internal off).
 *
 * The API still has the last word for contractors: an issue a contractor
 * creates is always saved external, whatever the web sends.
 */

/** The slice of a project payload the issue defaults are read from. */
export interface IssueDefaultsProject {
  id?: string | null;
  source_entity_extra_attributes?: Record<string, unknown> | null;
}

/** The Internal flag a new issue starts with on `project`. */
export function issueDefaultInternal(project: IssueDefaultsProject | null | undefined): boolean {
  const value = project?.source_entity_extra_attributes?.issue_default_internal;
  return !(value === false || value === 'false');
}

/**
 * The Internal flag a new issue starts with, reading the config only from the
 * issue's own project: `project` is the one the screen has loaded (the store
 * keeps whichever project was fetched last), `issueProjectId` the project the
 * issue is being created in (the page's / site's project). When the loaded
 * project is another one, or none is known, the default stays Internal.
 */
export function newIssueDefaultInternal(
  project: IssueDefaultsProject | null | undefined,
  issueProjectId?: string | null
): boolean {
  if (!project?.id) {
    return true;
  }
  if (issueProjectId && String(project.id) !== String(issueProjectId)) {
    return true;
  }
  return issueDefaultInternal(project);
}
